import React, { Component } from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import CampaignMediaBuyerModal from "./components/CampaignMediaBuyerModal";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';
import DynamicFormFilters from '../../../components/forms/DynamicFormFilters';
import {
  addCampaignMediaBuyer,
  deleteCampaignMediaBuyer,
  getCampaignMediaBuyersList,
  updateCampaignMediaBuyerProfile,
} from "../../../store/campaigns/media-buyers/actions";

class MediaBuyers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      addCampaignMediaBuyer: false,
      editData: null,
      activeFilters: {},
      statuses: [
        {
          id: 'true',
          name: 'Active',
        }, {
          id: 'false',
          name: 'Inactive'
        }
      ]
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.setState({
      activeFilters: {
        is_active: 'true',
      },
    });
    this.props.getCampaignMediaBuyersList({
      ...this.props.data,
      // is_active: 'true',
      page: 1,
      search: '',
      ordering: '',
      results: []
    });
    // this.props.getCampaignMediaBuyersList(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) { }

  handleTableChange = data => {
    this.props.getCampaignMediaBuyersList({
      ...data,
      // ...this.state.activeFilters,
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddMediaBuyerModal = () => {
    // view_campaignmediabuyermodel
    if (this.props.permissions?.["view_campaignmediabuyermodel"]) {
      this.setState(prevState => ({
        viewAddCampaignMediaBuyer: !prevState.viewAddCampaignMediaBuyer,
        editData: null,
      }));
    }
  };

  render() {

    const statusFormatter = (cell, row, rowIndex, formatExtraData) => {
      let status;
      let text;
      if (row.is_active) {
        status = "bg-success";
        text = "Active";
      } else {
        status = "bg-info";
        text = "Inactive";
      }
      return <span className={`badge ${status} font-size-12`}>{text}</span>;
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.number}"!`,
          onConfirm: () => {
            this.props.deleteCampaignMediaBuyer(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_campaignmediabuyermodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_campaignmediabuyermodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const onClickRow = (e, row, type) => {
      //this.props.history.push(`/media-buyers/${row.id}`);
      this.setState(prevState => ({
        viewAddCampaignMediaBuyer: !prevState.viewAddCampaignMediaBuyer,
        editData: type === "edit" ? row : null,
      }));
    };

    const columns = [
      {
        dataField: "number",
        text: "Number",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "number"),
      },
      {
        dataField: "user",
        text: "User",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "email"),
      },
      {
        dataField: "user__is_active",
        src: 'user__is_active',
        text: "Status",
        sort: true,
        formatter: statusFormatter,
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onFiltersChange = (filters, type, status) => {
      this.setState({
        activeFilters: {
          ...this.state.activeFilters,
          ...filters,
          ...(filters['is_active']?.length > 0 && { is_active: filters['is_active'][0] })
        },
      });
      this.props.getCampaignMediaBuyersList({
        ...this.props.data,
        ...this.state.activeFilters,
        ...filters,
        ...(filters['is_active']?.length > 0 && { is_active: filters['is_active'][0] }),
        page: 1,
      });
    }

    const handleDateRangeChange = () => {
      return 0;
    }

    return (
      <React.Fragment>
        {this.state.viewAddCampaignMediaBuyer && (
          <CampaignMediaBuyerModal
            toggle={this.toggleViewAddMediaBuyerModal}
            isOpen={this.state.viewAddCampaignMediaBuyer}
            data={this.props.data}
            usersInfo={this.props.usersInfo}
            addCampaignMediaBuyer={this.props.addCampaignMediaBuyer}
            updateCampaignMediaBuyerProfile={
              this.props.updateCampaignMediaBuyerProfile
            }
            editData={this.state.editData}
            permissions={this.props.permissions}
          />
        )}

        <div className="page-content">
          <ModifiedMetaTags title="Campaign media buyer| Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaign media buyers"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this media buyer? <br /> If you are
                  not sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              {/* <DynamicFormFilters
                filterDelay={10}
                FilterContainerClass="users--filters"
                onFiltersChange={onFiltersChange}
                onDateRangeChange={handleDateRangeChange}
                // isLoadingSelect={props.topReportsFiltersLoading}
                disableFilterBy
                // filtered_params={queryString.parse(
                //   this.props.history.location.search
                // )}
                filtersFields={[
                  {
                    filterData: this.state.statuses,
                    title: "Status",
                    plug: "Status...",
                    filterType: "is_active",
                    hasSelectAll: false,
                    singleSelect: true,
                    defaultValue: this.state.statuses[0],
                    style: {
                      marginLeft: "auto",
                    },
                  },
                ]}
                filtered_by={["is_active"]}
                // filtered_params={"all"}
                selectedDate={[]}
                dateFilters={[
                ]}
              /> */}
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions &&
                        this.props.permissions[
                        "add_campaignmediabuyermodel"
                        ] === "add_campaignmediabuyermodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={this.toggleViewAddMediaBuyerModal}
                          >
                            <i className="mdi mdi-plus me-1" /> Add campaign
                            media buyer
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

MediaBuyers.propTypes = {
  data: PropTypes.any,
  usersInfo: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignMediaBuyersList: PropTypes.func,
  addCampaignMediaBuyer: PropTypes.func,
  deleteCampaignMediaBuyer: PropTypes.func,
  updateCampaignMediaBuyerProfile: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.CampaignMediaBuyerList.data,
  usersInfo: state.CampaignMediaBuyerList.usersInfo,
  loading: state.CampaignMediaBuyerList.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCampaignMediaBuyersList,
  addCampaignMediaBuyer,
  deleteCampaignMediaBuyer,
  updateCampaignMediaBuyerProfile,
})(MediaBuyers);
